module.exports = __webpack_public_path__ + "static/media/stepper-manage-icon-active.018af2cb.svg";